document.addEventListener('DOMContentLoaded', () => {
  const burger = document.querySelector('.burger');
  const navLinks = document.getElementById('NavLinks');
  if (burger && navLinks) {
    burger.addEventListener('click', () => {
      const open = navLinks.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-carousel]').forEach((track) => {
    const section = track.closest('.carousel-section');
    if (!section) return;
    const prev = section.querySelector('.carousel-prev');
    const next = section.querySelector('.carousel-next');
    const scrollAmount = () => track.clientWidth * 0.75;
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: scrollAmount(), behavior: 'smooth' }));
  });

  document.querySelectorAll('.faq-question').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.faq-item');
      const isOpen = item.classList.contains('is-open');
      item.closest('.faq-list').querySelectorAll('.faq-item').forEach((el) => {
        el.classList.remove('is-open');
        el.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  initProductPage();
});

function initProductPage() {
  const section = document.querySelector('[data-product-section]');
  if (!section) return;

  const mainImage = document.getElementById('ProductMainImage');
  section.querySelectorAll('[data-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const src = thumb.getAttribute('data-image');
      if (mainImage && src) mainImage.src = src;
      section.querySelectorAll('[data-thumb]').forEach((el) => el.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  const qtyInput = section.querySelector('#Quantity');
  section.querySelectorAll('[data-qty]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      const delta = Number(btn.getAttribute('data-qty')) || 0;
      const next = Math.max(1, (Number(qtyInput.value) || 1) + delta);
      qtyInput.value = String(next);
    });
  });

  const variantsEl = document.getElementById('ProductVariantsJson');
  const variantInput = section.querySelector('[data-variant-id]');
  const addBtn = section.querySelector('[data-add-to-cart]');
  const priceEl = document.getElementById('ProductPrice');
  if (!variantsEl || !variantInput) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsEl.textContent || '[]');
  } catch (_) {
    variants = [];
  }

  const optionInputs = section.querySelectorAll('[data-option-input]');
  if (!optionInputs.length || !variants.length) return;

  const updateVariant = () => {
    const selected = {};
    section.querySelectorAll('.product-option').forEach((fieldset) => {
      const checked = fieldset.querySelector('input:checked');
      if (!checked) return;
      const name = checked.name.replace(/^options\[|\]$/g, '');
      selected[name] = checked.value;
    });

    const match = variants.find((variant) =>
      variant.options.every((value, index) => {
        const optionName = Object.keys(selected)[index];
        return selected[optionName] === value;
      })
    );

    if (!match) return;
    variantInput.value = match.id;
    if (addBtn) {
      addBtn.disabled = !match.available;
      const addLabel = addBtn.getAttribute('data-add-label') || 'Add to cart';
      const soldLabel = addBtn.getAttribute('data-soldout-label') || 'Sold out';
      addBtn.textContent = match.available ? addLabel : soldLabel;
    }
    if (priceEl && typeof match.price === 'number') {
      const pounds = (match.price / 100).toFixed(2);
      priceEl.innerHTML = `<span>£${pounds}</span>`;
    }
  };

  optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  updateVariant();
}
